/**
 * Progresso dos tutoriais, por usuário, no navegador.
 *
 * Fica no localStorage porque ninguém o lê fora da página de tutoriais: sem
 * painel do admin, gravar na API não serviria a ninguém. O custo é que o
 * progresso vale por navegador.
 */
const PREFIXO = 'erp-tutoriais:';

export const PROGRESSO_VAZIO = { concluidos: [], registro: [] };

const chave = (usuarioId) => `${PREFIXO}${usuarioId}`;

export const lerProgresso = (usuarioId) => {
  if (!usuarioId) return PROGRESSO_VAZIO;
  try {
    const salvo = JSON.parse(localStorage.getItem(chave(usuarioId)));
    if (!salvo || !Array.isArray(salvo.concluidos)) return PROGRESSO_VAZIO;
    return {
      concluidos: salvo.concluidos.filter((id) => typeof id === 'string'),
      registro: Array.isArray(salvo.registro) ? salvo.registro : [],
    };
  } catch {
    return PROGRESSO_VAZIO;
  }
};

export const salvarProgresso = (usuarioId, progresso) => {
  if (!usuarioId) return;
  try {
    localStorage.setItem(chave(usuarioId), JSON.stringify(progresso));
  } catch {
    // Navegador sem espaço ou em modo privado: o tutorial funciona, só não lembra.
  }
};

/**
 * Registra o fim de um tutorial. Feito depois de pulado vira feito; pulado
 * depois de feito não desfaz o feito.
 */
export const marcarFim = (progresso, tutorialId, como, em = new Date().toISOString()) => {
  const anterior = progresso.registro.find((r) => r.id === tutorialId);
  if (anterior && (anterior.como === 'feito' || como === 'pulado')) {
    return progresso.concluidos.includes(tutorialId)
      ? progresso
      : { ...progresso, concluidos: [...progresso.concluidos, tutorialId] };
  }
  return {
    concluidos: progresso.concluidos.includes(tutorialId)
      ? progresso.concluidos
      : [...progresso.concluidos, tutorialId],
    registro: [...progresso.registro.filter((r) => r.id !== tutorialId), { id: tutorialId, como, em }],
  };
};

export const comoTerminou = (progresso, tutorialId) =>
  progresso.registro.find((r) => r.id === tutorialId)?.como ?? null;

const chaveDaVoz = (usuarioId) => `erp-tutoriais-voz:${usuarioId}`;

/** A narração começa ligada; quem desliga no balão fica desligado. */
export const lerVozLigada = (usuarioId) => {
  try {
    return localStorage.getItem(chaveDaVoz(usuarioId)) !== 'desligada';
  } catch {
    return true;
  }
};

export const salvarVozLigada = (usuarioId, ligada) => {
  if (!usuarioId) return;
  try {
    localStorage.setItem(chaveDaVoz(usuarioId), ligada ? 'ligada' : 'desligada');
  } catch {
    // Sem como gravar, a escolha vale até recarregar a página.
  }
};
